import { DetailsRowProps } from "../../../../../../components/Details/components/Main/Grid/DetailsRow";
import {
  formatNumber,
  formatPrice,
} from "../../../../../../utils/formatNumber";
import useDocumentDetails from "../../../../../../hooks/useDocumentDetails";
import { DetailsRowValueVariants } from "../../../../../../components/Details/components/Main/Grid/DetailsRowValue";
import { Services } from "../../../../../../graphql/__GENERATED__/types";

const useProposalInfo = () => {
  const {
    documentData: { proposalResult, _id },
  } = useDocumentDetails();

  if (!proposalResult?._id) return [];
  return [
    [
      {
        label: "ID da proposta",
        value: proposalResult.externalId,
      },
      {
        label: "Seguradora",
        value: proposalResult.provider,
      },
      {
        label: "Produtividade Garantida",
        value: `${formatNumber(
          proposalResult.guaranteedProductivity,
          2,
          2 || 0
        )} sacas/ha`,
      },
      {
        label: "LMI Total",
        value: formatPrice(proposalResult.amounts?.lmi || 0),
      },
      proposalResult?.proposalFile?.fileKey && {
        label: "Proposta",
        variant: DetailsRowValueVariants.File,
        value: {
          file: {
            fileName: proposalResult.proposalFile?.fileName,
          },
          objectId: _id,
          fieldPath: "proposalFile",
          serviceName: Services.Documents,
        },
      },
    ].filter(Boolean),
    [
      {
        label: "Prêmio Total",
        value: formatPrice(proposalResult.amounts?.totalPremium || 0),
      },
      {
        label: "Subvenção Estadual",
        value: formatPrice(proposalResult.amounts?.stateSubvention || 0),
      },
      {
        label: "Subvenção Federal",
        value: formatPrice(proposalResult.amounts?.federalSubvention || 0),
      },
      {
        label: "Prêmio Final",
        value: formatPrice(proposalResult.amounts?.finalPremium || 0),
      },
    ],
  ] as DetailsRowProps[][];
};

export default useProposalInfo;
